import { Box, Grid, Typography } from "@mui/material";
import CandBMonogramNavy, { CandBMonogramWhite } from "src/icons/CandBMonogramNavy";
import { useState } from "react";
import {
  StyledChip,
  StyledLeftComponentContainer,
  StyledLeftPage,
} from "src/components/emailPreferences/styles";
import SubscribeRightComponent from "src/components/emailPreferences/SubscribeRightComponent";
import SubscribeRightSuccessComponent from "src/components/emailPreferences/SubscribeRightSuccessComponent";
import { useHistory } from "react-router-dom";
import { useSubscribeState } from "src/store/features/subscribe.slice";

const LeftComponent = () => {
  const history = useHistory();
  const { subscribeEmail } = useSubscribeState();
  return (
    <StyledLeftComponentContainer
      id="left-component"
      item
      xs={12}
      md={6}
      sx={{ display: { xs: "none", md: "flex" } }}>
      <StyledLeftPage container>
        <CandBMonogramNavy height={"32"} width={"28"} />
      </StyledLeftPage>
      <div style={{ textAlign: "center" }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: "bold", color: "#002035", mb: 2 }}>
          Thank you!
        </Typography>
        <Typography variant="body1" color="#002035" align="center">
          {` A verification link has been sent to your email, ${subscribeEmail}`}
          <br />
          {`Please check your inbox and follow the steps to complete your Portal registration.`}
          <br />
          {`(Please check your spam folder if you can't find it)`}
        </Typography>
      </div>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, marginBottom: "20px" }}>
        <Typography sx={{ color: "#7b858b", fontSize: "16px" }}>
          Already verified your account?
        </Typography>
        <StyledChip variant="outlined" onClick={() => history.push("/login")}>
          Login
        </StyledChip>
      </Box>
    </StyledLeftComponentContainer>
  );
};

/**
 * After signup page.
 * This page includes a text on the left which tells the user that a verification email has been sent to their email.
 * On the right, there is a form to subscribe to the newsletter.
 * @returns {JSX.Element} The JSX code for the component
 */
const AfterSignUpView = () => {
  const [stage, setStage] = useState<"initial" | "success">("initial");

  return (
    <div id="after-signup-page">
      <Grid sx={{ background: "#002035", padding: "20px", display: { sm: "flex", md: "none" } }}>
        <CandBMonogramWhite height={"32"} width={"28"} />
      </Grid>
      <Grid container sx={{ width: "100vw", height: "100vh" }}>
        <LeftComponent />
        {stage === "initial" && <SubscribeRightComponent setStage={setStage} />}
        {stage === "success" && <SubscribeRightSuccessComponent />}
      </Grid>
    </div>
  );
};

export default AfterSignUpView;
